import React from "react";
import PropTypes from "prop-types";

import { _cs } from "@togglecorp/fujs";

const portalChildrenClassName = ".portal-child";
const shownClassName = "portal-child-shown";
const hazeIdAttribute = "data-haze-id";

let hazeIdCounter = 0;

interface HazeChildProps {
  className?: string;
  [hazeIdAttribute]?: string;
}

interface HazeProps {
  children: React.ReactElement<HazeChildProps>;
}

function refreshLastModalStatus(modals: NodeListOf<Element> | Element[]) {
  modals.forEach((modal, i) => {
    const modalElement = modal as HTMLElement;
    modalElement.dataset.lastModal =
      i === modals.length - 1 ? "true" : "false";
  });
}

export default class Haze extends React.PureComponent<HazeProps> {
  private readonly hazeId = `haze-${hazeIdCounter++}`;

  static propTypes = {
    // modalRef: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    children: PropTypes.element.isRequired,
  };

  componentDidMount() {
    const classNames = document.body.className.split(" ");
    classNames.push(shownClassName);
    document.body.className = classNames.join(" ");

    const modals = document.querySelectorAll(portalChildrenClassName);
    refreshLastModalStatus(modals);
  }

  componentWillUnmount() {
    const classNames = document.body.className.split(" ");
    const index = classNames.findIndex((d) => d === shownClassName);
    if (index !== -1) {
      classNames.splice(index, 1);
    }
    document.body.className = classNames.join(" ");

    const modals = Array.from(
      document.querySelectorAll(portalChildrenClassName)
    ).filter((n) => (n as HTMLElement).dataset.hazeId !== this.hazeId);

    refreshLastModalStatus(modals);
  }

  render() {
    const { children } = this.props;

    return React.cloneElement(children, {
      className: _cs(children.props.className, "portal-child"),
      [hazeIdAttribute]: this.hazeId,
    });
  }
}
